// Per-select/per-option tag logging is too expensive at large-order scale (tens of
// thousands of console calls per load); opt in with ?debug_option_tags=1
const optionTagDebug = /[?&]debug_option_tags=/.test(window.location.search);
const tagLog = {
    info: optionTagDebug ? console.info.bind(console) : function () {},
    error: optionTagDebug ? console.error.bind(console) : function () {},
    group: optionTagDebug ? console.groupCollapsed.bind(console) : function () {},
    groupEnd: optionTagDebug ? console.groupEnd.bind(console) : function () {},
};

async function fetchProductAttributeOptions() {
    const formData = new FormData();
    let index = 0;
    window.saved_options = window.saved_options || {};

    const findSelects = function ($product) {
        // const $product = am.$(e).closest('.product');
        const selects = am.$($product).find('select[data-lazy="true"]');

        if (!selects || selects.length === 0) {
            return;
        }

        try { // to prevent the options not being populated on the orders
            const remote_dir = $product.attr('data-rsource');
            const is_remote = remote_dir.toUpperCase() !== 'LOCAL';
            if (is_remote) {
                return;
            }
        } catch (e) {
        }

        // const url = remote_dir.toUpperCase() === 'LOCAL' ? '/ajax/orders/get_attribute_options/' : '/ajax/orders/get_rattribute_options/';

        // formData.append('directory', remote_dir);

        selects.each(function (_index, select) {
            select.setAttribute('data-lazy', 'loading');
            const attr_id = select.getAttribute('data-lazy-attr-id');
            const pa_id = select.getAttribute('data-lazy-pa-id');
            const order_id = select.getAttribute('data-lazy-order-id');
            const attr_val = select.getAttribute('data-lazy-attr-val');
            const debug_hidden = select.getAttribute('data-debug-hidden');

            formData.append('params[' + index + '][pa]', pa_id);
            formData.append('params[' + index + '][attr]', attr_id);
            formData.append('params[' + index + '][attr_val]', attr_val);
            formData.append('params[' + index + '][order_id]', order_id);
            formData.append('params[' + index + '][name]', select.getAttribute('name'));

            if (!formData.has('debug_hidden')) {
                formData.append('debug_hidden', debug_hidden);
            }
            index++;
        });
    };

    am.$('#product_section_inner .product').each((_, e) => findSelects(e));
    Object.values(GUI.templates).forEach(findSelects);

    let query = '';
    const queryParams = location.search.parseQuery();

    if (queryParams.load_selected_options == 'true' || queryParams.load_selected_options == '1') {
        query = `load_selected_options=true`;
    }

    if (index > 0) {
        am.$.ajax({
            type: 'POST',
            url: `/ajax/orders/get_attribute_options/?${query}`,
            data: formData,
            processData: false,
            contentType: false,
            success: function (options) {
                if (!options) return;
                window.saved_options = options;

                Object.entries(GUI.templates).forEach(([key, html]) => {
                    let $html = am.$(html);

                    if ($html.length > 1) {
                        $html.each((_, e) => {
                            if (am.$(e).is('tr')) {
                                $html = am.$($html.get(_));
                            }
                        });
                    }

                    const selects = $html.find('select[data-lazy="true"]');

                    selects.each((_, s) => {
                        s.innerHTML = '';
                        updateSelectOptions(s);
                    });

                    if (selects.length > 0) {
                        GUI.templates[key] = $html.get(0).outerHTML;
                    }
                });

                am.$('select[data-lazy="loading"]').each((_, sel) => updateSelectOptions(sel));

                hydratePresetableSelects();
            }
        });
    }
}

/**
 * @param {HTMLSelectElement} select
 * @return {string|null} null when the select is not inside an order product (presets)
 */
function orderAttributeSelectKey(select) {
    const $product = select?.closest?.('.product[data-rsource]');
    const name = select?.getAttribute?.('name');

    if (!$product || !name) {
        return null;
    }

    return $product.getAttribute('data-rsource') + '\n' + name;
}

/**
 * @return {Set<string>}
 */
function orderAttributeSavedTagsAppliedKeys() {
    if (!(window.orderAttributeSavedTagsApplied instanceof Set)) {
        window.orderAttributeSavedTagsApplied = new Set();
    }

    return window.orderAttributeSavedTagsApplied;
}

/**
 * @param {HTMLSelectElement} select
 */
function markOrderAttributeSavedTagsApplied(select) {
    const key = orderAttributeSelectKey(select);

    if (key) {
        orderAttributeSavedTagsAppliedKeys().add(key);
    }
}

/**
 * @param {HTMLSelectElement} select
 */
function forgetOrderAttributeSavedTagsApplied(select) {
    const key = orderAttributeSelectKey(select);

    if (key) {
        orderAttributeSavedTagsAppliedKeys().delete(key);
    }
}

/**
 * @return {Map<string, HTMLSelectElement>}
 */
function buildOrderAttributeSelectIndex() {
    const index = new Map();

    for (const $select of document.querySelectorAll('.product[data-rsource] select[name^="products["]')) {
        const key = orderAttributeSelectKey($select);

        if (key !== null && !index.has(key)) {
            index.set(key, $select);
        }
    }

    return index;
}

async function fetchOrderAttributeOptionTags() {
    if (window.orderAttributeOptionTagsLoading === true) {
        return;
    }
    if (!theOrder || theOrder.isNew() || theOrder.getOrderStatus() === ORDER_STATUS_BID) {
        return;
    }
    const orderId = theOrder.getId();

    let savedData = window.orderAttributeOptionTags;
    if (!savedData) {
        window.orderAttributeOptionTagsLoading = true;
        try {
            savedData = null;
            const $orderAttributeSavedTags = document.querySelector("#order_attribute_saved_tags")?.value;
            if ($orderAttributeSavedTags) {
                savedData = JSON.parse($orderAttributeSavedTags);
            }
        } catch (e) {
            savedData = null;
        }
        if (savedData == null) {
            savedData = await fetch(`/ajax/orders/get_attribute_option_tags/${orderId}/`).then(r => r.json());
        }
        window.orderAttributeOptionTagsLoading = false;
        window.orderAttributeOptionTags = savedData;
    }

    const appliedKeys = orderAttributeSavedTagsAppliedKeys();
    let selectIndex = null;
    const resolveSelect = function (instance, name) {
        if (instance === null || instance === undefined) {
            return null;
        }

        if (selectIndex === null) {
            selectIndex = buildOrderAttributeSelectIndex();
        }

        return selectIndex.get(instance + '\n' + name) || null;
    };

    const applySavedTags = function (instance, name, options, skipReloaded) {
        const key = instance + '\n' + name;

        if (appliedKeys.has(key)) {
            return;
        }

        const $select = resolveSelect(instance, name);
        if (!$select) {
            return;
        }

        if (skipReloaded && $select.dataset.optionTagsReloaded === 'true') {
            // Select attribute is dirty and saved tags won't be loaded.
            appliedKeys.add(key);
            return;
        }

        let applied = false;

        for (const [optionId, tagsData] of Object.entries(options)) {
            const $option = $select.querySelector(`option[value="${optionId}"]`);

            if (!$option) {
                continue;
            }

            $option.dataset.savedTags = JSON.stringify({
                tags: tagsData.tags ? {tags: tagsData.tags, type: tagsData.type} : null,
                overrides: tagsData.overrides ? {
                    tags: tagsData.overrides.tags,
                    type: tagsData.overrides.type,
                } : null,
            });
            applied = true;
        }

        if (applied) {
            appliedKeys.add(key);
        }
    };

    for (const product of savedData) {
        const opId = product.op_id;
        const opiId = product.opi_id;
        if ('tags_item' in product && typeof product.tags_item === 'object' && product.tags_item !== null && Object.keys(product.tags_item).length > 0) {
            for (const [attrName, options] of Object.entries(product.tags_item)) {
                applySavedTags(product.instance, `products[${opId}][items][${opiId}][${attrName}]`, options, true);
            }
        }
        if ('tags_group' in product && typeof product.tags_group === 'object' && product.tags_group !== null && Object.keys(product.tags_group).length > 0) {
            for (const [attrName, options] of Object.entries(product.tags_group)) {
                applySavedTags(product.instance, `products[${opId}][${attrName}]`, options, false);
            }
        }
    }
}

/**
 * @param {HTMLSelectElement} select
 */
function refreshProductImageFor(select) {
    if (typeof get_product_image !== "function" || !select) {
        return;
    }

    const cell = select.closest(".pao_td");
    if (!cell || !cell.querySelector("div.pao_pic")) {
        return;
    }

    const product = select.closest(".product");
    try {
        get_product_image(select, product ? product.getAttribute("data-base") : null);
    } catch (e) {
        tagLog.error("refreshProductImageFor failed for", select.getAttribute("name"), e);
    }
}

/**
 * Moves a select from data-lazy="end" (options already fetched but stored in
 * window.saved_options) to data-lazy="loaded" by injecting its option list.
 *
 * @param {HTMLSelectElement} select
 * @return {boolean} true when the options were injected.
 */
function loadLazySelectOptions(select) {
    const name = select.getAttribute('name');
    const originalSelectTemplate = select.dataset.originalSelectTemplate;
    const originalSelectName = select.dataset.originalSelectName;

    if (saved_options.hasOwnProperty(name)) {
        select.innerHTML = saved_options[name];
        select.setAttribute('data-lazy', 'loaded');
        delete select.dataset.hasOptionTags;
        delete saved_options[name];
        forgetOrderAttributeSavedTagsApplied(select);
        refreshProductImageFor(select);
        return true;
    }

    if (originalSelectTemplate && saved_options.hasOwnProperty(originalSelectTemplate)) {
        select.innerHTML = saved_options[originalSelectTemplate];
        select.setAttribute('data-lazy', 'loaded');
        delete select.dataset.hasOptionTags;
        forgetOrderAttributeSavedTagsApplied(select);
        /**@type {HTMLSelectElement} originalSelect*/
        const originalSelect = document.querySelector(`[name="${originalSelectName}"]`)
        if (originalSelect && originalSelect.value) {
            select.value = originalSelect.value
        }
        refreshProductImageFor(select);
        return true;
    }

    console.error('select has no options', name);
    return false;
}

/**
 * Fills every presettable select as soon as the option lists arrive, without waiting
 * for the product hover.
 */
async function hydratePresetableSelects() {
    const selects = document.querySelectorAll(
        '#product_section_inner .product select[data-presetable="true"][data-lazy="end"]'
    );

    if (selects.length === 0) {
        return;
    }

    const hydrated = [];

    for (const select of selects) {
        if (loadLazySelectOptions(select)) {
            hydrated.push(select);
        }
    }

    if (hydrated.length === 0 || typeof theOrder === 'undefined' || !theOrder) {
        return;
    }

    await fetchOrderAttributeOptionTags();

    tagLog.group('Presetable selects');
    toggleSelectOptionsVisibilityByCompanyTags(hydrated);
    tagLog.groupEnd();
}

function updateSelectOptions(sel) {
    const $sel = am.$(sel);
    $sel
        .attr('data-lazy', 'end')
        .find('option[data-old-text]')
        .each(function (_i, opt) {
            opt.innerText = opt.getAttribute('data-old-text');
        });

    if (sel.options.length === 0) {
        const name = $sel.attr('name');
        if (saved_options.hasOwnProperty(name)) {
            $sel.html(saved_options[name]).attr('data-lazy', 'loaded');
            delete sel.dataset.hasOptionTags;
            forgetOrderAttributeSavedTagsApplied(sel);
            refreshProductImageFor(sel);
        }
    }

    return $sel;
}

/**
 * @param {HTMLSelectElement[] | null} selects - Selects to toggle visibility for. If not provided, it will toggle visibility for all selects in the page.
 * */
function toggleSelectOptionsVisibilityByCompanyTags(selects = null) {
    // DEV-12799: support kill switch — a URL containing disable_attr_tags skips the
    // company-tag option filtering entirely (same opt-in style as debug_option_tags).
    if (/[?&]disable_attr_tags/.test(window.location.search)) {
        return;
    }

    const randomId = (length = 6) => Math.random().toString(36).substring(2, length + 2);
    const localCompanyTags = theOrder?.getCompanyTags().map(tag => String(tag.id));

    if (localCompanyTags.length === 0) {
        tagLog.info("Local company has no tags.");
    }

    if (!("selectOptions" in window)) {
        window.selectOptions = {};
    }

    /**@type {HTMLSelectElement[]} $selects*/
    const $selects = selects ?? document.querySelectorAll("#product_section_inner .product select, select.preset");

    // DEV-12799: apply the saved order tags ONCE per invocation, not once per select.
    // The fetch itself was cached, but every call still re-ran the full apply loop
    // (products x attrs x options); calling it inside the loop below multiplied that
    // by the select count — the main cause of the 11-minute order-page load.
    fetchOrderAttributeOptionTags();

    for (const $select of $selects) {
        const selectName = $select.dataset.attrName ?? $select.dataset.attr;
        const isPreset = $select.classList.contains("preset");
        const productIsNew = isPreset ? false : theOrder?.productIsNew($select);
        const productIsB2b = isPreset ? false : theOrder?.productIsB2b($select);
        const isBid = theOrder?.getOrderStatus() === ORDER_STATUS_BID;
        const companyB2bTags = productIsB2b ? theOrder?.getInstanceCompanyB2bTags($select).map(tag => String(tag.id)) : [];
        const companyTags = productIsB2b ? companyB2bTags : localCompanyTags;

        if (!selectName) {
            console.error("Select has no name", $select);
            continue;
        }

        if ("lazy" in $select.dataset && $select.dataset.lazy !== "loaded" && $select.dataset.lazy !== "false") {
            continue;
        }

        if ($select.dataset.hasOptionTags === "0") {
            continue;
        }

        const identifier = $select.dataset.identifier || (selectName + "_" + randomId());

        /**
         * Here we are storing all the options in an object and then restoring them to delete when required
         * because Safari doesn't allow hiding option elements on a select.
         *
         * Damn Apple.
         *
         * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/hidden#browser_compatibility
         * */
        if (!(identifier in window.selectOptions)) {
            if (!$select.querySelector("option[data-tags]")) {
                $select.dataset.hasOptionTags = "0";
                tagLog.info(`[${selectName}] has no tagged options: skipping ${$select.options.length} options here and on every later pass.`);
                continue;
            }
            window.selectOptions[identifier] = $select.innerHTML;
            $select.dataset.identifier = identifier;
        } else if ($select.dataset.tagsRemoved === "1") {
            const selectedValue = $select.value;
            $select.innerHTML = window.selectOptions[identifier];
            $select.value = selectedValue;
        }

        /**@type {HTMLOptionsCollection} $options*/
        const $options = $select.querySelectorAll('option');
        const hasOptgroups = $select.getElementsByTagName("optgroup").length > 0;
        let removedAnOption = false;

        tagLog.group(`${isPreset ? "PRESET" : ""}[${selectName}]`);
        for (const /**HTMLOptionElement*/ $option of $options) {
            const optionId = $option.value;
            const tagsJson = $option.dataset.tags;
            if (!tagsJson || optionId === "") {
                if (optionTagDebug) {
                    tagLog.info(`Option (${$option.text})[${optionId}] has no tags or value is empty. Skipping.`);
                }
                continue;
            }
            const optionLabel = optionTagDebug ? $option.text : "";

            const hasSavedTags = "savedTags" in $option.dataset;

            // Cache the parsed payloads on the option. They only change when the option list is
            // rebuilt from window.selectOptions, which replaces the nodes anyway.
            const savedTags = hasSavedTags ? ($option._savedTags ??= JSON.parse($option.dataset.savedTags)) : {};
            const currentTags = ($option._currentTags ??= JSON.parse(tagsJson));
            const emptyTags = {tags: {type: "inclusive", tags: []}};

            // const dataTags = (isBid || productIsNew || isPreset) ? currentTags : (hasSavedTags ? savedTags : emptyTags);
            let tempTags = null;
            // dumb but easy for debugging
            if (isBid || productIsNew || isPreset) {
                tempTags = currentTags;
            } else {
                tempTags = hasSavedTags ? savedTags : emptyTags;
            }
            const dataTags = tempTags;
            const optionsTags = dataTags.overrides ? dataTags.overrides : dataTags.tags;

            const tagsType = optionsTags?.type;
            const tags = optionsTags?.tags ?? [];

            const debugData = !optionTagDebug ? undefined : {
                isBid,
                isPreset,
                productIsNew,
                productIsB2b,
                localCompanyTags,
                companyB2bTags,
                companyTags,
                hasSavedTags,
                savedTags,
                currentTags,
                emptyTags,
                dataTags,
                optionsTags,
                tagsType,
                tags,
            };

            if (tags.length === 0) {
                tagLog.info(`Option (${optionLabel})[${optionId}] has no tags. Skipping.`, debugData);
                continue;
            }

            const hasSavedTagsMessage = !optionTagDebug ? "" : (hasSavedTags ? "[saved tags]" : "[no saved tags]");
            const tagsMessage = !optionTagDebug ? "" : (productIsB2b ? `[instance company b2b tags: ${companyB2bTags.join(", ")}]` : `[local company tags: ${localCompanyTags.join(", ")}]`);
            const optionTagsDisplay = !optionTagDebug ? "" : `${tags.map(tag => tag.value).join(", ")}`;

            const $header = hasOptgroups ? $option.closest('optgroup') : null;

            if (tagsType === "inclusive") {
                // Only companies with these tags can see this option
                if (!tags.some(tag => companyTags.includes(String(tag.value))) && companyTags.length > 0) {
                    $option.remove();
                    removedAnOption = true;
                    tagLog.info(`{${tagsType}}: Hiding (${optionLabel})[${optionId}], ${tagsMessage}, option tags: ${optionTagsDisplay}${', ' + hasSavedTagsMessage}`, debugData);
                } else if (companyTags.length === 0 && tags.length > 0) {
                    $option.remove();
                    removedAnOption = true;
                    tagLog.info(`{${tagsType}}: Hiding (${optionLabel})[${optionId}], company has no tags, option require this tags: ${optionTagsDisplay}${', ' + hasSavedTagsMessage}`, debugData);
                }
            } else if (tagsType === "exclusive") {
                // Companies with these tags cannot see this option
                if (tags.some(tag => companyTags.includes(String(tag.value))) && companyTags.length > 0) {
                    $option.remove();
                    removedAnOption = true;
                    tagLog.info(`{${tagsType}}: Hiding (${optionLabel})[${optionId}], ${tagsMessage}, option tags: ${optionTagsDisplay}${', ' + hasSavedTagsMessage}`, debugData);
                }
            }

            // hide header if it has no options
            if ($header?.childElementCount === 0) {
                $header?.remove();
                console.info(`Hiding empty header: ${$header?.label}`);
            }
        }
        tagLog.groupEnd();

        if (removedAnOption) {
            $select.dataset.tagsRemoved = "1";
        }
    }
}

/**
 * @param {HTMLSelectElement} select
 * @return {boolean}
 */
function reloadSelectOptionTags(select) {
    const reloaded = select.dataset.optionTagsReloaded === 'true';
    const orderStatus = theOrder?.getOrderStatus();
    const isBid = orderStatus === ORDER_STATUS_BID;

    if (isBid) {
        tagLog.info("Order is a BID, reloading is not required.");
        return true;
    }

    if (reloaded) {
        tagLog.info("Select is already reloaded.", select);
        return true;
    }

    select.dataset.optionTagsReloaded = 'true';
    markOrderAttributeSavedTagsApplied(select);

    toggleSelectOptionsVisibilityByCompanyTags([select]);

    tagLog.info("Select attribute is dirty and saved tags won't be loaded.", select);

    return false;
}

am.$(async function () {
    fetchProductAttributeOptions();
    await fetchOrderAttributeOptionTags();

    setTimeout(function () {
        am.$('#product_section_inner .product select[data-lazy="loading"]').each(function (_, select) {
            const $selected_option = am.$(select).find('option:selected');
            if ($selected_option) {
                $selected_option.attr('data-old-text', $selected_option.text());
                $selected_option.text('Loading...');
            }
        })
    }, 250);

    am.$(document).on('mouseenter', '#product_section_inner .product', function (e) {
        const $product = am.$(e.target).closest('.product');
        const product = $product.get(0);
        const selects = $product.find('select[data-lazy="end"]');

        // DEV-12820: this fires on every pointer entry. Re-filtering a product whose selects
        // are all hydrated repeats the whole option sweep for nothing — on an imported order
        // that is tens of thousands of options per pointer move. Only the selects hydrated by
        // THIS hover need filtering; once none are left the product is done.
        if (selects.length === 0 && product?.dataset.optionTagsFiltered === "1") {
            return;
        }

        const productName = $product.find('.dh h2').text();

        selects.each(function (_index, select) {
            loadLazySelectOptions(select);
        });
        const lazyLoadedSelects = $product.find('select[data-lazy="loaded"]').toArray();
        const nonLazySelects = $product.find('select[data-lazy="false"]').toArray();
        tagLog.group('Selects of', productName);
        toggleSelectOptionsVisibilityByCompanyTags([...lazyLoadedSelects, ...nonLazySelects]);
        tagLog.groupEnd();

        if (product) {
            product.dataset.optionTagsFiltered = "1";
        }
    });
});